"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var HUNDRED_PERCENT = 100;

function calculateChange(currentValue, previousValue) {
  var changeValue = currentValue - previousValue;

  if (previousValue === 0 && changeValue === 0) {
    return 0;
  } else if (previousValue === 0 && changeValue < 0) {
    return -1 * HUNDRED_PERCENT;
  } else if (previousValue === 0 && changeValue > 0) {
    return HUNDRED_PERCENT;
  }

  return changeValue / previousValue * HUNDRED_PERCENT;
}
/**
 * A class to represent the the options that are passed to the MwChartTwoYAxisLineOptions.tooltipFormatter
 * @param {object} options - Not neeeded externally
 *
 * @property {string} seriesName - Name for the series of the current point
 * @property {number} [change=0] - The difference in percent between the previous point and this one. NOTE: hasChange will be true if this value is valid.
 * @property {boolean} hasChange - A boolean stating whether this point has a change value
 * @property {string} key - The key for the current point
 * @property {number} value - The value for the current point
 *
 */


var MwChartTwoYAxisLineTooltipOptions = function MwChartTwoYAxisLineTooltipOptions(_ref) {
  var point = _ref.point,
      series = _ref.series;
  (0, _classCallCheck2.default)(this, MwChartTwoYAxisLineTooltipOptions);
  var change = 0;
  var hasChange = false;

  if (point.index > 0) {
    hasChange = true;
    change = calculateChange(point.y, series.data[point.index - 1].y);
  }

  this.seriesName = series.name;
  this.change = change;
  this.hasChange = hasChange;
  this.key = series.data[point.index].category;
  this.value = point.y;
};

exports.default = MwChartTwoYAxisLineTooltipOptions;